import { Typography } from '@mui/material';
import { MuiAvatar } from '@/components/avatar/MuiAvatar';
import { MuiChip } from '@/components/chip/MuiChip';
import IbowOfficePNG from '@/../public/dx_normal.png';

export function IbowOfficeChip() {
  return (
    <MuiChip
      avatar={<MuiAvatar src={IbowOfficePNG.src} />}
      label={
        <Typography variant="JP/Body/s/Medium/Tight" sx={{ color: '#0079C3' }}>
          DXステーション
        </Typography>
      }
      sx={{
        backgroundColor: '#F5FAF9',
        borderRadius: 1,
        px: 1,
        py: 0.5,
        '.MuiChip-avatar': { m: 0 },
        '.MuiChip-label': {
          pl: 0.5,
          pr: 0,
        },
      }}
    />
  );
}
